module.exports = __webpack_public_path__ + "img/featured-banner.e99634bd.png";